<template>
  <Loading v-if="loading" :data-loading="loading" />
  <div v-else class="card-chart-container" :data-loading="loading">
    <VueApexCharts
      :options="settings.chartOptions"
      :series="settings.series"
      :class="props.class"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script setup lang="ts">
export interface LineChartProps {
  xAxis: string[];
  series: ApexAxisChartSeries;
  loading?: boolean;
  title: string;
  class?: string;
  height?: number;
  unit?: string;
  formatter?: (val: number) => string;
}

const { xAxis, series, loading, title, ...props } = defineProps<LineChartProps>();

import { formatNumber } from "@/utils";
import type { ApexOptions } from "apexcharts";
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";
import Loading from "./Widgets/Loading.vue";
import moment from "moment";
import { Colors } from "@/constants";

const settings = computed(() => ({
  series,
  chartOptions: {
    chart: {
      type: "line",
      zoom: {
        enabled: false
      },
      fontFamily: "RobotoCustom"
    },
    dataLabels: {
      enabled: true,
      formatter(val) {
        return (props.formatter ?? formatNumber)(val as number, 1);
      }
    },
    colors: [Colors.Blue, Colors.Green],
    stroke: {
      curve: "smooth",
      width: 2
    },
    title: {
      text: title,
      align: "left",
      style: {
        fontFamily: "RobotoCustomSemiBold",
        fontWeight: 600,
        fontSize: "15px"
      }
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5
      }
    },
    xaxis: {
      categories: xAxis
    },
    markers: {
      size: 5,
      hover: {
        size: 5
      }
    },
    yaxis: {
      labels: {
        formatter(val, { dataPointIndex, seriesIndex }) {
          const formatter = props.formatter ?? formatNumber;
          const formatted = props.unit
            ? `${formatter(Number(val))} ${props.unit}`
            : `${formatter(Number(val))}`;
          if (dataPointIndex !== undefined && dataPointIndex !== -1 && seriesIndex !== undefined) {
            return `<span class="text-normal">${(series[seriesIndex].data[dataPointIndex] as any)?.meta?.label ?? moment((series[seriesIndex].data[dataPointIndex] as any)?.meta?.month, "YYYY-MM").format("MMM YYYY")} :</span> ${formatted}`;
          }
          return formatted;
        },
        offsetX: -15
      }
    },
    tooltip: {
      x: {
        show: true
      },
      y: {
        show: true
      }
    }
  } as ApexOptions
}));
</script>
